import { z } from 'my-zod'
import { operatorsModel } from './operators-model'

export const createOperator = operatorsModel
  .pick({
    businessName: true,
    dealerNumber: true,
    website: true,
    reservationSystem: true,
    reservationSystemOther: true,
    programName: true,
    eliteDesignationDate: true,
    businessPhone: true,
    businessEmail: true,
    outfitterLegalEntity: true,
    preferredDealerId: true,
    indirectVendor: true,
    optInEmployeeDiscount: true,
    groupId: true,
    departmentNumber: true,
    prospectSource: true,
    prospectStatus: true,
    forecastedCloseDate: true,
    dealConfidence: true,
    lifecycleStatus: true,
    outfitterSignedDate: true,
    deactivationReasonCode: true,
    deactivationDescription: true,
    lossDate: true,
    probationDate: true,
    accountSpecialistId: true,
    riskSpecialistId: true,
    fleetManagerId: true,
    serviceOpsId: true,
    addresses: true,
    customerDestinationAddressId: true,
    shippingAddressId: true,
    billingAddressId: true,
    legalAddressId: true,
    vehicleDeliveryAddressId: true,
    latitude: true,
    longitude: true,
    landingSlug: true,
    marketPresenceId: true,
    competitiveAffiliations: true,
    competitiveBrandsUtilized: true,
    competitiveRentalInventory: true,
    businessType: true,
    typeOfExperience: true,
    yearRoundSeason: true,
    primaryContactId: true,
    businessDevelopmentRepId: true,
    businessDevelopmentSupport: true,
    reviewLinks: true,
    masterServiceDealerEnrollmentStatus: true
  })
  .augment({
    // nullable here because if it is not supplied, we will automatically create the group for the operator
    groupId: z.number().nullable(),
    aboutTheBusiness: z.string().optional(),
    expectedImpact: z.string().optional(),
    vehicleTypes: z.string().array().optional(),
    numberOfVehicles: z.number().optional()
  })

export type createOperator = z.infer<typeof createOperator>
